<template>
  <div class="mt-2">
    <!-- <div :style="[!noInnerWidth ? { width: width } : {}]"> -->
    <div :style="{ width: !noInnerWidth ? width : 'auto' }">
      <div class="max-height-100">
        <b-table
          :busy="isLoading"
          head-variant="light"
          :items="items"
          :fields="getAllFields"
          :current-page="currentPage"
          per-page="0"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          :no-local-sorting="true"
          @sort-changed="sortingChanged"
          :sticky-header="height"
          no-border-collapse
          responsive
          show-empty
          empty-text="Non ci sono informazioni da mostrare"
          small
        >
          <template #table-busy>
            <table-skeleton />
          </template>
          <template #empty>
            <template v-if="newTaskBtn">
              <div
                class="d-flex flex-column justify-content-center align-items-center my-3"
                style="max-width: max-content; margin-inline: auto"
              >
                <p class="mb-2">
                  Effettua una ricerca oppure, se non trovi risultati, crea una
                  nuova Nota cliccando sul pulsante qui sotto
                </p>
                <b-button
                  class="btn-create"
                  type="button"
                  variant="primary"
                  size="sm"
                  @click="onAddNewTask"
                  title="Crea"
                  :disabled="!canVerb(resource, 'store')"
                  style="max-width: max-content"
                >
                  <b-icon icon="plus-circle" aria-hidden="true"></b-icon>
                  Crea
                </b-button
                >
              </div>
            </template>
            <template v-else>
              <div
                :class="`text-center empty-results ${
                  isTableInModal ? 'my-3' : 'my-5'
                }`"
              >
                <div
                  v-if="
                    isTableInModal ||
                    performedSearch ||
                    automaticPerformedSearch
                  "
                  class="mb-1"
                >
                  Non sono stati trovati risultati
                </div>
                <template v-else-if="!isTableInModal">
                  <b-button
                    class="btn btn--smaller"
                    variant="primary"
                    size="sm"
                    title="Ricerca libera"
                    data-type="special-btn"
                    @click="freeSearch"
                  >
                    Nuova ricerca libera
                  </b-button
                  >
                  <span class="or">oppure</span>
                  <b-button
                    :class="`btn--smaller btn--transparent align-items-center gap-3${
                      filterCount ? ' active' : ''
                    }`"
                    size="sm"
                    title="Apri i filtri"
                    data-type="special-btn"
                    v-b-toggle.sidebar-1
                  >
                    <base-icon name="filters" width="23" height="23"/>
                    Ricerca
                    con filtri{{ filterCount ? ` (${filterCount})` : "" }}
                  </b-button>
                </template>
              </div>
            </template>
          </template>
          <template #cell(users)="{ item }">
            {{ retrieveUsers(item) }}
          </template>
          <template #cell(description)="{ item }" v-if="items.length">
            <div style="max-width: 340px">
              {{ item.description }}
            </div>
          </template>
          <!-- <template #cell(contraente)="{ item }" v-if="items.length">
            <span
              v-html="
                toInfoData(
                  item.insurance_policies[0].registry,
                  'registryfullname'
                )
              "
            ></span>
          </template>
          <template #cell(broker)="{ item }" v-if="items.length">
            <span
              v-html="toBrokerInfo(item.insurance_policies[0].broker_id)"
            ></span>
          </template> -->
          <template #cell(entity)="{ item }">
            {{
              getTaskableLabel(
                item.registries && item.registries.length
                  ? item.registries[0].pivot.taskable_type
                  : item.insurance_policies && item.insurance_policies.length
                    ? item.insurance_policies[0].pivot.taskable_type
                    : "--"
              )
            }}
          </template>
          <template #cell(custom_actions)="row">
            <div style="display: flex">
              <div class="action-buttons">
                <b-button
                  v-if="hasNewPolicy(row.item)"
                  size="sm"
                  variant="lisaweb"
                  @click="sendToPolicy(row.item)"
                  class="mt-1 mr-1"
                  title="Passa nota a polizza sostituente"
                >
                  <b-icon icon="arrow-up"></b-icon>
                </b-button>
              </div>
              <div class="action-buttons">
                <b-button
                  v-if="hasOldPolicy(row.item)"
                  size="sm"
                  variant="lisaweb"
                  @click="sendAutomatically(row.item)"
                  class="mt-1 mr-1"
                  title="Passa automaticamente"
                >
                  <b-icon icon="arrow-repeat"></b-icon>
                </b-button>
              </div>
              <div class="action-buttons">
                <b-button
                  size="sm"
                  variant="lisaweb"
                  @click="sendNever(row.item)"
                  class="mt-1 mr-1"
                  title="Non passare mai"
                >
                  <b-icon icon="x"></b-icon>
                </b-button>
              </div>
            </div>
          </template>
          <template #cell(actions)="row">
            <div class="action-buttons">
              <b-button
                v-if="actions.includes('infomodal')"
                size="sm"
                variant="lisaweb"
                @click="openModal(row.item, row.index, $event.target)"
                class="mt-1 mr-1"
                title="Modale Dettagli"
              >
                <base-icon name="eye" width="22"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('details')"
                size="sm"
                variant="lisaweb"
                @click="row.toggleDetails"
                class="mt-1 mr-1"
                :title="
                  row.detailsShowing ? 'Chiudi dettagli' : 'Apri dettagli'
                "
              >
                <b-icon v-if="row.detailsShowing" icon="chevron-up"></b-icon>
                <b-icon v-else icon="chevron-down"></b-icon>
              </b-button>

              <b-button
                v-if="actions.includes('edit')"
                size="sm"
                variant="lisaweb"
                @click="onEdit(row.item.id, row.item)"
                class="mt-1 mr-1"
                title="Modifica"
              >
                <base-icon name="edit" width="22"></base-icon>
              </b-button>

              <b-button
                v-if="actions.includes('destroy')"
                size="sm"
                variant="lisaweb"
                @click="onDestroy(row.item.id)"
                class="mt-1 mr-1"
                title="Elimina"
              >
                <base-icon name="trash" width="22" height="22"></base-icon>
              </b-button>
            </div>
          </template>

          <template #row-details="row">
            <b-card>
              <b-row
                class="mb-2"
                v-for="(value, key) in customized(row.item)"
                :key="key"
              >
                <b-col sm="3" class="text-sm-right"
                ><b>{{ key | capitalize }}:</b></b-col
                >
                <b-col>{{ value }}</b-col>
              </b-row>
            </b-card>
          </template>
          <template #cell()="{ value }">
            <span>{{ value }}</span>
          </template>
        </b-table>
      </div>

      <pagination-skeleton v-if="isLoading && !noPagination" />
      <div
        class="pagination-wrapper"
        v-if="!isLoading && !noPagination && items.length"
      >
        <div class="info">
          <div class="show-text">
            <p>
              <label for="per-page-select-registry"
              >Numero di risultati per pagina:</label
              >
            </p>
          </div>
          <div class="group">
            <b-form-group label-for="per-page-select">
              <b-form-select
                id="per-page-select-registry"
                v-model="perPage"
                :options="pageOptions"
                style="width: 68px"
                size="sm"
                @change="onPageChange(1)"
                :disabled="!items.length"
              ></b-form-select>
            </b-form-group>
          </div>
          <div class="page">
            <p>
              Risultati da
              <strong>{{ formatItemsFrom }}</strong> a
              <strong>{{ formatItemsTo }}</strong> su un totale di
              <strong>{{ formatTotalItems }}</strong>
            </p>
          </div>
        </div>
        <div class="info-action">
          <div class="pagination" v-if="totalItems">
            <b-pagination
              v-model="currentPage"
              limit="3"
              :total-rows="totalItems"
              :per-page="perPage"
              size="sm"
              @change="onPageChange"
            >
              <template #page="{ page, active }">
                <span :data-active="active">{{
                    page.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                  }}</span>
              </template>
              <template v-slot:first-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:prev-text>
                <span
                ><base-icon
                  scale="-1"
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:next-text>
                <span
                ><base-icon
                  name="chevron_right_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
              <template v-slot:last-text>
                <span
                ><base-icon
                  name="chevron_right_last_rounded"
                  width="16"
                  height="16"
                /></span>
              </template>
            </b-pagination>
          </div>
          <div
            class="input_pagination"
            v-if="
              totalItems && !noInputPaginator && totalPages && totalPages > 3
            "
          >
            <base-input-pagination
              @pagination="onInputPagination"
            ></base-input-pagination>
          </div>
        </div>
      </div>

      <template v-if="items.length">
        <div>
          <p
            style="
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 8px;
            "
          >
            <b-icon icon="arrow-up" font-scale="1.5"></b-icon>
            <span
            >Passa a polizza sostituente (nel caso di successive sostituzioni
              di polizza verrà richiesta nuovamente conferma)</span
            >
          </p>
        </div>
        <div>
          <p
            style="
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 8px;
            "
          >
            <b-icon icon="arrow-repeat" font-scale="1.5"></b-icon>
            <span
            >Passa automaticamente (nel caso di successive sostituzioni di
              polizza verrà automaticamente passata alla sostituente)</span
            >
          </p>
        </div>
        <div>
          <p
            style="
              display: flex;
              align-items: center;
              gap: 5px;
              margin-bottom: 8px;
            "
          >
            <b-icon icon="x" font-scale="1.5"></b-icon>
            <span
            >Non passare mai questa nota (tale nota non verra passata alla
              polizza sostituente)</span
            >
          </p>
        </div>
      </template>

      <!-- Modale dettagli -->
      <b-modal
        :id="infomodalName"
        @hidden="onModalHidden"
        :title="modalTitle"
        size="xl"
        scrollable
        ok-only
        ok-variant="lisaweb"
        header-bg-variant="lisaweb"
        no-close-on-backdrop
      >
        <div>
          <b-tabs content-class="pt-1" lazy v-model="tabIndex">
            <b-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="setTab(tab, index)"
              :title="tab.text"
              :active="index === tabIndex"
              title-item-class="lisaweb"
            >
              <button-group-tab></button-group-tab>
              <keep-alive>
                <component
                  v-if="selected === tab.name"
                  :is="selected"
                  :resourceId="modalResourceId"
                  @fetch="fetch"
                ></component>
              </keep-alive>
            </b-tab>
          </b-tabs>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import template from "./template";
import BaseIcon from "@/components/BaseIcon";
import ButtonGroupTab from "@/components/ButtonGroupTab";
import {getTaskableLabel} from "@/utils/transforms";
// import { mapGetters } from "vuex";
import {RepositoryFactory} from "@/repositories/RepositoryFactory";
import BaseInputPagination from "../form/BaseInputPagination.vue";

export default {
  name: "TasksTable",
  extends: template,

  data() {
    return {
      isLoading: true,
      tabs: [],
      salesmen: [],
      selected: "General",
      modalResourceId: null,
      tabIndex: 0,
    };
  },
  components: {
    BaseInputPagination,
    BaseIcon,
    ButtonGroupTab,
  },
  props: {
    performedSearch: {
      type: Boolean,
      default: false,
    },
    filterCount: {
      type: Number,
      default() {
        return 0;
      },
    },
    isTableInModal: {
      type: Boolean,
      default: false,
    },
    newTaskBtn: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getTaskableLabel,
    hasNewPolicy(item) {
      return !!(
        item.insurance_policies_new_policy?.[0]?.new_policies_lite?.[0]
      );
    },
    hasOldPolicy(item) {
      return !!(item.insurance_policies_new_policy?.[0]?.old_policy);
    },
    sendNever(item) {
      this.isLoading = true;
      const {title, description, is_public, task_type, users} = item;
      let payload = {
        description: description,
        inheritance: 0,
        is_public: is_public.value,
        task_type: task_type.value,
        title: title,
        users: users.value,
      };
      const Repo = RepositoryFactory.get("task");
      Repo.update(item.id, payload)
        .then(() => {
          this.$emit("forcedFetch");
        })
        .catch((error) => {
          this.isLoading = false;
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onAddNewTask() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: {
          /* remove the / character if it is the first character of a string */
          returnUrl: this.$route.path.replace(/^\/(.*)/, "$1"),
        },
      });
    },
    freeSearch() {
      this.$emit("manualFetch");
    },
    sendAutomatically(item) {
      const oldPolicy = item.insurance_policies_new_policy?.[0]?.old_policy;
      if (!oldPolicy) return;
      this.isLoading = true;
      let payload = {
        insurance_policy: {},
      };
      payload.insurance_policy[oldPolicy.id] = {};
      const Repo = RepositoryFactory.get("task");
      Repo.pivot_update(item.id, "insurance_policy", payload)
        .then(() => {
          const {title, description, is_public, task_type, users} = item;
          let payload = {
            description: description,
            inheritance: 1,
            is_public: is_public.value,
            task_type: task_type.value,
            title: title,
            users: users.value,
          };
          Repo.update(item.id, payload)
            .then(() => {
              this.$emit("forcedFetch");
            })
            .catch((error) => {
              this.isLoading = false;
              let errMsg = this.$getErrorMessage(error);
              this.$showSnackbar({
                preset: "error",
                text: `${errMsg}`,
              });
            });
        })
        .catch((error) => {
          this.isLoading = false;
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    sendToPolicy(item) {
      const newPolicy = item.insurance_policies_new_policy?.[0]?.new_policies_lite?.[0];
      if (!newPolicy) return;
      this.isLoading = true;
      let payload = {
        insurance_policy: {},
      };
      payload.insurance_policy[newPolicy.id] = {};
      const Repo = RepositoryFactory.get("task");
      Repo.pivot_update(item.id, "insurance_policy", payload)
        .then(() => {
          this.$emit("forcedFetch");
        })
        .catch((error) => {
          this.isLoading = false;
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    // toBrokerInfo(id) {
    //   if (!id) return "-";
    //   return this.salesmen.find((s) => s.value == id).text ?? "-";
    // },
    retrieveUsers(item) {
      const ret = item.users.map((user) => user.username).join(", ");
      return ret ? ret : "-";
    },
    customized(item) {
      // console.debug("Item: ", item);
      let c = {};
      c.descrizione = item.description;
      c.titolo = item.title;

      return c;
    },

    // ...mapGetters("auth", {
    //   getSalesmen: "salesmen",
    // }),
  },
  computed: {
    formatItemsFrom() {
      if (!this.totalItems) return "";
      return this.items_from.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatItemsTo() {
      if (!this.totalItems) return "";
      return this.items_to.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    formatTotalItems() {
      if (!this.totalItems) return "";
      return this.totalItems.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  // mounted() {
  //   this.salesmen = this.getSalesmen();
  // },
};
</script>
